import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';
import { Page, Scan } from '@models/binder.model';
import { BinderService } from '@services/binder.service';
import { ScannerService } from '@services/scanner.service';

@Component({
  selector: 'lgb-page-item',
  imports: [
    UiModule,
    CommonModule
  ],
  templateUrl: './page-item.html',
  styleUrl: './page-item.css',
})
export class PageItem {
  // input/output
  readonly page=input.required<Page>();
  readonly scan=input.required<Scan | null>();
  readonly lazy=input(false);
  readonly canFull=input(true);
  readonly admin=input(true);
  readonly fullScreen=output<boolean>();
  readonly unlike=output<boolean>();

  //services
  readonly binderS=inject(BinderService);
  readonly scanService=inject(ScannerService);

  getImgPage(){
    return this.binderS.getImgPage(this.page(), this.scan());
  }

  isFinish(){
    return (this.scan() && this.scan().state=='finished');
  }

  toggleFavoritePage(){
    this.binderS.toggleFavoritePage(this.page().ident)
      .subscribe(p => {
        this.page().isFavorite=p.isFavorite;
        if(!p.isFavorite)
          this.unlike.emit(true);
      });
  }

}
